import React from 'react';
import {useTranslation} from 'react-i18next';
import {useFormikContext} from 'formik';
import * as css from './TicketValidity.css';
import ValiditySection from './components/ValiditySection';
import ToggleSection from './components/ToggleSection';

interface TicketFormValues {
    startDateActive: boolean;
    startDate?: number;
    startTime?: number;
    endDateActive: boolean;
    endDate?: number;
    endTime?: number;
    displayBeforeSale: boolean;
    displayAfterSale: boolean;
}

function TicketValidity() {
    const {t} = useTranslation('ticket');
    const {values} = useFormikContext<TicketFormValues>();

    return (
        <css.container>
            <css.sectionsWrapper>
                <ValiditySection
                    title={t('validityStartTime')}
                    subtitle={t('validityStartTimeDesc')}
                    enabledFieldName="startDateActive"
                    dateFieldName="startDate"
                    timeFieldName="startTime"
                    dateLabel={t('startDate')}
                    timeLabel={t('startTime')}
                    isEnabled={values.startDateActive}
                    activeLabel={t('active')}
                    inActiveLabel={t('inActive')}
                />

                <css.divider />

                <ValiditySection
                    title={t('validityEndTime')}
                    subtitle={t('validityEndTimeDesc')}
                    enabledFieldName="endDateActive"
                    dateFieldName="endDate"
                    timeFieldName="endTime"
                    dateLabel={t('endDate')}
                    timeLabel={t('endTime')}
                    isEnabled={values.endDateActive}
                    activeLabel={t('active')}
                    inActiveLabel={t('inActive')}
                />
            </css.sectionsWrapper>

            <ToggleSection
                fieldName="displayBeforeSale"
                title={t('displayBeforeSaleTitle')}
                description={t('displayBeforeSaleDesc')}
                activeLabel={t('active')}
                inActiveLabel={t('inActive')}
                statusLabel={t('recommended')}
            />

            <ToggleSection
                fieldName="displayAfterSale"
                title={t('displayAfterSaleTitle')}
                description={t('displayAfterSaleDesc')}
                activeLabel={t('active')}
                inActiveLabel={t('inActive')}
                showHelpIcon
            />
        </css.container>
    );
}

export default TicketValidity;